import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isProfileLoading } from 'platform/user/selectors';
import { useToggleLoadingValue } from 'platform/utilities/feature-toggles';
import { initDismissedModals, dismissModal } from '../actions/index';
import config from '../config';
import { selectActiveModal, selectOnboardingModal } from '../selectors';

export default function OnboardingModalContainer() {
  const dispatch = useDispatch();
  const togglesLoading = useToggleLoadingValue();
  const modal = useSelector(state => selectActiveModal(state, config));
  const userOnboardingShow = useSelector(
    state => state.user?.profile?.onboarding?.show,
  );
  const profileLoading = useSelector(isProfileLoading);
  const onboardingModal = useSelector(selectOnboardingModal);
  const initializedRef = useRef(false);

  useEffect(() => {
    // Initialize once after profile loading settles.
    if (
      !initializedRef.current &&
      !onboardingModal.isInitialized &&
      !profileLoading
    ) {
      dispatch(initDismissedModals(userOnboardingShow));
      initializedRef.current = true;
    }
  }, [
    dispatch,
    onboardingModal.isInitialized,
    profileLoading,
    userOnboardingShow,
  ]);

  if (togglesLoading || !modal) {
    return null;
  }

  const dismiss = () => dispatch(dismissModal());

  return <modal.component dismiss={dismiss} />;
}
